<template>
  <v-img
    :src='device()'
    :aspect-ratio='aspectRatio()'
    contain
    class='white lighten-2'
  >
  </v-img>
</template>

<script>

const pulse3ChImage = require('../assets/img/3CH_PulseAlarm.png');
const pulse12ChImage = require('../assets/img/12CH_PulseAlarm.png');
const pulse48ChImage = require('../assets/img/48CH_PulseAlarm.png');

const ct3ChImage = require('../assets/img/3CH_CT.png');
const ct12ChImage = require('../assets/img/12CH_CT.png');
const ct48ChImage = require('../assets/img/48CH_CT.png');

const voltage3ChImage = require('../assets/img/3CH_Vin.png');
const voltage12ChImage = require('../assets/img/12CH_Vin.png');
const voltage48ChImage = require('../assets/img/48CH_Vin.png');

export default {
  name: 'DeviceImage',
  props: {
    type: String,
  },
  data() {
    return {
      storeState: this.$store.state,
    };
  },
  methods: {
    aspectRatio() {
      if (this.storeState.data.deviceInfo.model === 48) {
        return '0.65';
      }
      return '1';
    },

    device() {
      let image = null;
      switch (this.type) {
        case 'pulse':
          switch (this.storeState.data.deviceInfo.model) {
            case 3:
              image = pulse3ChImage;
              break;
            case 48:
              image = pulse48ChImage;
              break;
            case 12:
            default:
              image = pulse12ChImage;
          }
          break;
        case 'ct':
          switch (this.storeState.data.deviceInfo.model) {
            case 3:
              image = ct3ChImage;
              break;
            case 48:
              image = ct48ChImage;
              break;
            case 12:
            default:
              image = ct12ChImage;
          }
          break;
        case 'voltage':
          switch (this.storeState.data.deviceInfo.model) {
            case 3:
              image = voltage3ChImage;
              break;
            case 48:
              image = voltage48ChImage;
              break;
            case 12:
            default:
              image = voltage12ChImage;
          }
          break;
        default:
          image = '';
      }

      return image;
    },
  },
};
</script>
